<template>
  <div v-if="product.properties.stock_status === 'available'" class="delivery-card">
    <div class="delivery-header">
      <span class="delivery-badge">EN STOCK</span>
    </div>

    <div class="delivery-line">
      <span class="delivery-label">Livraison estimée :</span>
      <span class="delivery-date">{{ deliveryDate }}</span>
    </div>

    <div class="delivery-deadline">
      Commandez <span v-html="cutoffText" />
    </div>
  </div>
</template>

<script>
import { cutoffFor, deliveryDate, nextCutoff } from '~/utils/deliveryDate'

export default {
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  data () {
    return { openDays: null, now: new Date() }
  },
  computed: {
    // Clôture de l'entrepôt d'expédition : Halluin 12h00, les autres 13h30.
    cutoff () {
      return cutoffFor(this.product?.properties?.ship_from)
    },
    deliveryDate () {
      const weight = this.product?.properties?.weight || this.product?.properties?.gross_weight || 0
      return this.formatDeliveryDate(deliveryDate(this.now, weight, this.openDays, this.cutoff))
    },
    cutoffText () {
      const cutoff = nextCutoff(this.now, this.openDays, this.cutoff)
      const diffMs = cutoff - this.now
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60))
      const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))
      if (diffHours < 24) {
        return `dans les <strong>${diffHours} h ${diffMinutes} min</strong>.`
      }
      const dayName = this.getDayName(cutoff.getDay())
      return `avant <strong>${dayName} ${cutoff.getDate()} ${this.getMonthName(cutoff.getMonth())} à ${this.cutoff.hour}h${String(this.cutoff.minute).padStart(2, '0')}</strong>.`
    }
  },
  async mounted () {
    this.now = new Date()
    if (this.product?.properties?.ship_from !== 'HAL') return
    try {
      // $api (plugins/api.js) préfixe déjà /api côté navigateur.
      const { data } = await this.$api.get('/shipping-calendar', { params: { location: 'HAL' } })
      this.openDays = data.open_days || null
    } catch (e) {
      this.openDays = null
    }
  },
  methods: {
    formatDeliveryDate (date) {
      const dayName = this.getDayName(date.getDay())
      const dayNumber = date.getDate()
      const monthName = this.getMonthName(date.getMonth())

      // Capitaliser la première lettre
      return `${dayName.charAt(0).toUpperCase() + dayName.slice(1)} ${dayNumber} ${monthName}`
    },
    getDayName (dayIndex) {
      const days = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
      return days[dayIndex]
    },
    getMonthName (monthIndex) {
      const months = [
        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
      ]
      return months[monthIndex]
    }
  }
}
</script>

<style scoped>
.delivery-card {
  background: #f4f8f5;
  border: 1px solid #dce7e1;
  border-radius: 10px;
  padding: 14px 16px;
  margin: 14px 0;
  font-size: 14px;
  line-height: 1.4;
}

/* Badge EN STOCK */
.delivery-badge {
  display: inline-block;
  --tw-bg-opacity: 1;
  background: rgba(76, 175, 80, var(--tw-bg-opacity));
  color: #ffffff;
  font-weight: 600;
  font-size: 13px;
  padding: 6px 14px;
  border-radius: 6px;
  letter-spacing: 0.3px;
}

/* Ligne livraison */
.delivery-line {
  margin-top: 10px;
  color: #1f2933;
}

.delivery-label {
  font-weight: 500;
}

.delivery-date {
  font-weight: 700;
}

/* Ligne heure limite */
.delivery-deadline {
  margin-top: 6px;
  font-size: 13px;
  color: #4b5563;
}
</style>
